const GET_LINK_DATA_URL = 'https://api.microlink.io';
const previewCache = new Map();

// High-resolution brand assets for sites that block web scrapers
const KNOWN_PLATFORMS = {
  'instagram.com': {
    title: 'Instagram',
    description: "Capture and share the world's moments.",
    image:
      'https://upload.wikimedia.org/wikipedia/commons/a/a5/Instagram_icon.png',
  },
  'github.com': {
    title: 'GitHub',
    description: 'Where the world builds software.',
    image:
      'https://github.githubassets.com/images/modules/logos_page/GitHub-Mark.png',
  },
  'twitter.com': {
    title: 'X (formerly Twitter)',
    description: 'From breaking news and entertainment to sports and politics.',
    image:
      'https://abs.twimg.com/responsive-web/client-web/icon-ios.b1fc727a.png',
  },
  'x.com': {
    title: 'X (formerly Twitter)',
    description: 'From breaking news and entertainment to sports and politics.',
    image:
      'https://abs.twimg.com/responsive-web/client-web/icon-ios.b1fc727a.png',
  },
  'linkedin.com': {
    title: 'LinkedIn',
    description:
      'Connect to opportunity and manage your professional identity.',
    image:
      'https://static.licdn.com/scds/common/u/images/logos/favicons/v1/favicon.ico',
  },
  'facebook.com': {
    title: 'Facebook',
    description: 'Connect with friends, family and other people you know.',
    image:
      'https://upload.wikimedia.org/wikipedia/commons/0/05/Facebook_Logo_%282019%29.png',
  },
};

export const fetchLinkPreview = async (url) => {
  if (!url) return { hasPreview: false };

  if (previewCache.has(url)) {
    return previewCache.get(url);
  }

  let hostname = '';
  try {
    hostname = new URL(url).hostname.replace('www.', '').toLowerCase();
  } catch {
    return { hasPreview: false };
  }

  // 1. Check YouTube (Native free oEmbed)
  if (hostname.includes('youtube.com') || hostname.includes('youtu.be')) {
    try {
      const oembedRes = await fetch(
        `https://www.youtube.com/oembed?url=${encodeURIComponent(
          url
        )}&format=json`
      );
      if (oembedRes.ok) {
        const oembedData = await oembedRes.json();
        const ytResult = {
          url,
          title: oembedData.title || 'YouTube Video',
          description: `Uploaded by ${oembedData.author_name || 'YouTube'}`,
          image:
            oembedData.thumbnail_url ||
            'https://www.youtube.com/s/desktop/f17255be/img/favicon_144x144.png',
          hasPreview: true,
        };
        previewCache.set(url, ytResult);
        return ytResult;
      }
    } catch {
      // Continue to next provider
    }
  }

  // 2. Try Microlink OpenGraph API
  try {
    const res = await fetch(
      `${GET_LINK_DATA_URL}?url=${encodeURIComponent(url)}`
    );
    if (res.ok) {
      const json = await res.json();
      const data = json?.data;

      if (json?.status === 'success' && data?.title) {
        const result = {
          url,
          title: data.title || '',
          description: data.description || '',
          image:
            data.image?.url ||
            `https://www.google.com/s2/favicons?domain=${hostname}&sz=128`,
          hasPreview: true,
        };
        previewCache.set(url, result);
        return result;
      }
    }
  } catch {
    // Suppress network/400 errors and use brand fallback
  }

  // 3. Fallback for Known Scraper-Protected Sites (Instagram, GitHub, etc.)
  for (const [domain, meta] of Object.entries(KNOWN_PLATFORMS)) {
    if (hostname.includes(domain)) {
      const brandResult = {
        url,
        title: meta.title,
        description: meta.description,
        image: meta.image,
        hasPreview: true,
      };
      previewCache.set(url, brandResult);
      return brandResult;
    }
  }

  // 4. Universal Fallback using High-Res Google Favicon
  const defaultResult = {
    url,
    title: hostname.charAt(0).toUpperCase() + hostname.slice(1),
    description: url,
    image: `https://www.google.com/s2/favicons?domain=${hostname}&sz=128`,
    hasPreview: true,
  };
  previewCache.set(url, defaultResult);
  return defaultResult;
};
